import React from 'react';
import './Stars.scss';

const Stars = () => (
    <div id="stars">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
    </div>
);
export default Stars;